module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selected_metavariables":"Selected metavariables","computation_time":"Computation time"},"fr":{"selected_metavariables":"Métavariables sélectionnées","computation_time":"Temps de calcul"}}')
  delete Component.options._Ctor
}
